import AuthLayout from "./AuthLayout.vue";
export default AuthLayout;
